import React from "react";
import get from "lodash.get";
import { Typography } from "@mui/material";

import { Annotation } from "config/const";
import {
  TimePickerElement,
  DateTimePickerElement,
  TextFieldElement,
  DatePickerElement,
  SelectElement,
  CheckboxElement,
  RadioButtonGroup,
} from "components/FormElement";
import { RequiredDot, TextFieldStyle } from "../Styled";

function mergeExtends(key = "", uiProps = {}) {
  const extend = get(uiProps.extends, key, {});
  return [...Object.entries(extend), ...Object.entries(uiProps)].reduce(
    (acc, [k, v]) => {
      if (typeof v === "object" && typeof acc[k] === "object")
        acc[k] = { ...acc[k], ...v };
      else acc[k] = v;
      return acc;
    },
    {}
  );
}

export function annotationItemProps(annotation, uiProps = {}) {
  const base = {
    name: annotation.key,
    required: annotation.required,
    placeholder: annotation.placeholder || "請輸入...",
    helperText: " ",
  };
  const others = mergeExtends(annotation.key, uiProps);

  switch (annotation.type) {
    case Annotation.Type.INPUT:
    case Annotation.Type.CHECKBOX:
    case Annotation.Type.DATE:
    default:
      return {
        ...base,
        ...others,
      };
    case Annotation.Type.OPTIONS:
    case Annotation.Type.RADIO:
      return {
        ...base,
        labelKey: "label",
        valueKey: "key",
        options: annotation.sources,
        sx: { width: "100%" },
        ...others,
      };
  }
}

function dateElementByMode(mode, itemProps = {}) {
  switch (mode) {
    case Annotation.DateMode.DATE:
    default:
      return <DatePickerElement inputFormat="YYYY/MM/DD" {...itemProps} />;
    case Annotation.DateMode.DATETIME:
      return (
        <DateTimePickerElement {...itemProps} inputFormat="YYYY/MM/DD HH:mm" />
      );
    // case Annotation.DateMode.LUNAR:
    //   return <DatePickerElement {...itemProps} inputFormat="YYYY/MM/DD" />;
    case Annotation.DateMode.TIME:
      return <TimePickerElement inputFormat="HH:mm" {...itemProps} />;
  }
}

export function annotationItemByType(annotation, itemProps = {}) {
  if (annotation.key === "phone") {
    itemProps.inputmode = "numeric";
  }
  switch (annotation.type) {
    case Annotation.Type.INPUT:
    default:
      return <TextFieldElement {...itemProps} sx={TextFieldStyle} />;
    case Annotation.Type.OPTIONS:
      return <SelectElement {...itemProps} sx={TextFieldStyle} />;
    case Annotation.Type.DATE:
      return dateElementByMode(annotation.mode, itemProps);
    case Annotation.Type.CHECKBOX:
      return <CheckboxElement {...itemProps} />;
    case Annotation.Type.RADIO:
      return <RadioButtonGroup {...itemProps} />;
  }
}

function AnnotationLabel({ required = false, label = "" }) {
  return (
    <Typography variant="body1" sx={{ color: "white" }}>
      {label}
      {required && <RequiredDot>*</RequiredDot>}
    </Typography>
  );
}

export default function AnnotationItem({
  annotation = {},
  renderTitle,
  ...props
}) {
  const itemProps = annotationItemProps(annotation, props);
  const title = !annotation.hideLabel ? (
    renderTitle ? (
      renderTitle()
    ) : (
      <AnnotationLabel
        required={annotation.required}
        label={annotation.label}
      />
    )
  ) : null;
  const el = annotationItemByType(annotation, itemProps);
  return (
    <>
      {title}
      {el}
    </>
  );
}
